<!--Copy and paste the code below into
a separate view file.
Add content in v-col component, as described below.-->
<template>
    <!-- Responsive home page layout -->
      <v-app>    
        <v-container>
          <v-row justify="center">
            <!-- Navigation Bar -->
            <v-col cols="12" class="mb-8">
              <NavBar/>
            </v-col>
            <!-- Display content in v-col below.
             If you want multiple columns, side-by-side,
             create more columns and use cols="12" md="6" lg="4"
             or similiar to adjust columns according to breakpoint as
             desired. Look at the responsiveness and source code
             of the Home page as an example -->
            <v-col cols="12"> 
                <h1 class="flex-box">
                    ChatBot Page
                </h1>
            </v-col>
          </v-row>
        </v-container>
        <!-- Footer -->
        <MENDFooter></MENDFooter>
      </v-app>
    </template>
    
    <script>
    // Imported components present in each page.
    import MENDFooter from './MENDFooter.vue';
    import NavBar from './NavBar.vue';
    
    export default {
      name: 'ChatBot',
      components: {
        NavBar,
        MENDFooter,
      },
    }
    </script>
    
    <style>
    * {
      font-family: 'Montserrat';
    }
    
    .flex-box {
      display: flex;
      justify-content: center;
    }
    </style>
    
